module.exports = __webpack_public_path__ + "img/huace10.2ca6a2ed.jpg";